import { render, staticRenderFns } from "./TeacherPurchaseConfirmation.vue?vue&type=template&id=1cd28272"
import script from "./TeacherPurchaseConfirmation.vue?vue&type=script&lang=js"
export * from "./TeacherPurchaseConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports